let rule = {}
// 电话
rule.tel = /^((0\d{2,3}-?\d{7,8})|(1[3456789]\d{9}))$/
// 手机号
rule.mobile = /^(1[3456789]\d{9})$/
// 正整数
rule.num = /^[1-9]\d*$/
rule.num2 = /^([0]|[1-9]|[1-9]\d{0,100})$/
// 保留两位小数
rule.decimal = /^(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/
// 小于53的正整数
rule.num1 = /^([0-9]|[1-4][0-9]|(5[0-2]))$/
// 正数
rule.positive = /^[+]{0,1}(\d{0,5})$|^[+]{0,1}(\d{0,5}\.\d{0,2})*$/
// 大于0的数字（包含整数，小数）
rule.moreZero = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/
// 百分数
rule.percentage = /^((100)|[0-9]|([1-9][0-9])|([1-9][0-9]\.[0-9][0-9])|([1-9][0-9]\.[0-9])|([0-9]\.[0-9][0-9])|([0-9]\.[0-9]))$/
rule.letter = /^[A-Za-z0-9]+$/
// 身份证
rule.id_card = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/
// 不可以输入中文字符
rule.char = /^[^\u4e00-\u9fa5]{0,}$/
export default rule



// WEBPACK FOOTER //
// ./src/api/public/rule.js